//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { venues_list } from '@/apis/stadium'
import { service_update, service_detail } from '@/apis/product'
import { oss_files } from '@/apis/config'
//import { fetchAll } from '@/apis/mch'

export default {
    data() {
        //表單校驗
        const rules = {
            venueCode: [{ required: true, message: '請選擇所屬場館！' }],
            //mchNo: [{ required: true, message: '請選擇所屬品牌！' }],
            name: [{ required: true, message: '請輸入產品名稱！' }],
            typeCode: [{ required: true, message: '請選擇服務類型！' }],

            organizer: [{ required: true, message: '請輸入辦理單位！' }],
            mainImage: [{ required: true, message: '請上傳封面圖！' }],
            syllabus: [{ required: true, message: '請輸入產品大綱！' }],
            reminder: [{ required: true, message: '請輸入註意事項！' }],
            description: [{ required: true, message: '請輸入產品說明！' }],
            // maxParticipants: [{ required: this.peopleNumberRadio == 0, message: '請輸入產品說明！' }],         
            // maleQuota: [{ required: this.peopleNumberRadio == 1, message: '請輸入產品說明！' }],    
            // femaleQuota: [{ required: this.peopleNumberRadio == 1, message: '請輸入產品說明！' }],    
            status: [{ required: true, message: '請選擇狀態！' }],
        };

        const form = {
            venueCode: undefined,           //所屬場館
            mchNo: undefined,                //所屬品牌
            name: undefined,                //產品名稱
            typeCode: undefined,            //服務類型
            maxParticipants: undefined,     //人數上限
            maleQuota: undefined,           //男（人數）
            femaleQuota: undefined,         //女（人數）
            unlimitedQuota: undefined,      //無性別限制（人數）

            mainImage: undefined,           //封面圖
            organizer: undefined,           //辦理單位
            syllabus: undefined,            //大綱
            description: undefined,         //說明
            outline: undefined,             //活動內容描述
            reminder: undefined,            //註意事項或提醒
            groupSize: undefined,           //成團人數
            activityImages: '',
            activityVideos: '',
            facilities: undefined,                 //其他服務列表
            suitableAge: '',
            ticketType: '1',
            timeCode: '',
            startTime: '',
            endTime: '',
            points: '1',
            sportType: '1',                  //球種類型編碼
            status: undefined,
            isPopular: false,
            isFeatured: false,
            /* 冗餘字段 */
            datepicker: '',
            activityVideo: ''
        };
        return {
            id: '',
            spinning: false,
            fileLoading: false,
            config: {
                gymnasiums: [],
                fetch: [],
            },
            //接收到的上傳文件
            fileList: [],
            previewVisible: false,
            previewImage: '',
            //是否限制人數
            peopleNumberRadio: 0,
            form,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        await this.onPageConfig();
        await this.onPageLoad();
    },
    methods: {
        // async getFetch() {

        //     try {
        //         //加載所屬場館
        //         const data = { mchName: '', state: 1, pageSize: 999, pageNumber: 1 };
        //         const res = await fetchAll(data) || {};
        //         if (res.code == 0) {
        //             this.config.fetch = res.data.records;
        //         } else {
        //             if (res.msg)
        //                 throw new Error(res.msg);
        //         }
        //     } catch (error) {
        //         this.$message.error(error.message);
        //     }
        // },
        async getVenueList() {
            try {
                //加載所屬場館
                const data = { venueCode: '', venueName: '', sportTypeCode: '', status: '', areaCode: '', pageSize: 999, pageNumber: 1 };
                const res = await venues_list(data) || {};
                if (res.code == 0) {
                    this.config.gymnasiums = res.data.records;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageConfig() {
            this.getVenueList();
            //this.getFetch();
        },
        async onPageLoad() {
            try {
                if (this.id > 0) {
                    const res = await service_detail(this.id);
                    if (res.code == 0) {
                        const item = res.data || {};
                        const form = { ...this.form };
                        form.venueCode = item.venueCode;
                        form.name = item.name;
                        form.typeCode = item.typeCode;
                        form.maxParticipants = item.maxParticipants;
                        form.unlimitedQuota = item.maxParticipants;
                        form.sportType = item.sportType;
                        form.ticketType = item.ticketType;
                        form.mainImage = item.mainImage;
                        form.timeCode = item.timeCode;
                        form.points = item.points;
                        form.suitableAge = item.suitableAge;
                        form.startTime = item.startTime;
                        form.endTime = item.endTime;
                        form.mchNo = item.mchNo;
                        form.datepicker = [item.startTime, item.endTime];
                        form.isPopular = item.isPopular;
                        form.isFeatured = item.isFeatured;
                        this.peopleNumberRadio = form.genderRestrict || 0;
                        form.status = `${item.status}`;

                        form.id = this.id;
                        if (item.extInfo) {
                            form.organizer = item.extInfo.organizer;
                            const images = JSON.parse(item.extInfo.activityImages);
                            if (images.length > 0) {
                                form.activityImages = images[0];
                            } else {
                                form.activityImages = '';
                            }

                            const videos = JSON.parse(item.extInfo.activityVideos);
                            if (videos.length > 0) {
                                form.activityVideos = videos[0];
                            } else {
                                form.activityVideos = '';
                            }
                            if (item.extInfo.facilities) {
                                form.facilities = JSON.parse(item.extInfo.facilities);
                            }
                            form.outline = item.extInfo.outline;
                            form.reminder = item.extInfo.reminder;
                            form.syllabus = item.extInfo.syllabus;
                            form.description = item.extInfo.description;
                        }

                        this.form = form;
                        this.onLoadFile();
                    } else {
                        this.$message.error(res.msg);
                    }
                }
            } catch (error) {
                this.$message.error(error.message);
            }

        },

        /* 活動時間修改 */
        handleDatepickerChange(dateArray) {
            if (dateArray.length > 1) {
                this.form.startTime = dateArray[0].format('YYYY-MM-DD');
                this.form.endTime = dateArray[1].format('YYYY-MM-DD');
            } else {
                this.form.startTime = '';
                this.form.endTime = '';
            }
        },
        async onLoadFile() {
            function getFileName(path) {
                const regex = /([^\/\\]+)$/;
                const match = regex.exec(path);
                if (match) {
                    return match[1];
                } else {
                    return undefined;
                }
            }
            const url = this.form.mainImage;
            if (url) {
                this.fileList = [{
                    uid: '-1',
                    name: getFileName(url),
                    status: 'done',
                    url: url
                }]
            }
        },

        /* 圖片預覽 */
        async handleFilePreview(file) {
            function getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            }
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        /* 關閉圖片預覽 */
        handlePreviewCancel() {
            this.previewVisible = false;
        },
        /* 圖片上傳 */
        async handleFileChange({ fileList }) {
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData);
                    if (res.code == 0) {
                        this.form.mainImage = res.data;
                        this.fileList = validFiles;
                    } else {
                        this.$message.error(res.msg);
                    }
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            } else {
                this.fileList = fileList;
                this.form.mainImage = '';
            }
        },

        /* 表單提交驗證 */
        onFormValidate(e, v) {
            e.preventDefault();
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async onSubmit(e) {
            this.spinning = true;
            try {
                const form = { ...this.form };
                form.id = this.id;
                form.datepicker = '';
                form.facilities = JSON.stringify(form.facilities);
                form.activityVideos = JSON.stringify([form.activityVideos]);
                form.activityImages = JSON.stringify([form.activityImages]);
                form.unlimitedQuota = form.maxParticipants;
                form.genderRestrict = this.peopleNumberRadio;
                if (form.genderRestrict == 0) {
                    form.maleQuota = '';
                    form.femaleQuota = '';
                } else {
                    form.maxParticipants ='';
                }

                const res = await service_update(form) || {};
                if (res.code == 0) {
                    this.$message.success('提交完成');
                    this.$router.push('/product');
                } else {
                    if (res.msg)
                        throw new Error(res.msg)
                }

            } catch (error) {
                console.log(error);
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
